import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('a-card', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _c('a-space', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm.$route.query.isIssue == 1 ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.distribute
    }
  }, [_vm._v(" 分发 ")]) : _vm._e(), _c('a-button', {
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回")]), _vm.form.docStatus === 2 && _vm.form.tempId != 4 ? _c('a-button', {
    on: {
      "click": _vm.printTemp
    }
  }, [_vm._v(" 打印 ")]) : _vm._e(), _vm.form.docStatus === 5 && _vm.form.tempId == 4 ? _c('a-button', {
    on: {
      "click": _vm.printTemp
    }
  }, [_vm._v(" 打印 ")]) : _vm._e()], 1)], 1)]), _c('a-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_c('a-row', [_c('a-col', {
    staticStyle: {
      "border": "1px solid #e9e9e9"
    }
  }, [_vm.form.tempId == 1 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校纪委办拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.fileCode) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.urgency) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.secretLevel) + " ")])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileName))])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  }), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
    attrs: {
      "type": "link"
    },
    on: {
      "click": function click($event) {
        return _vm.handleDownPreview(_vm.item);
      }
    }
  }, [_vm._v(" 下载 ")]) : _vm._e()], 2)])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.signauditopinion) + " "), _c('div', {
    staticClass: "sign-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("纪委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem",
      "white-space": "nowrap"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.signsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.signsignimg !== '' && _vm.form.docData.signsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.signsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-second-height-x2"
  }, [_c('div', [_vm._v("初核：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.firstauditopinion) + " "), _c('div', {
    staticClass: "sign-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("纪委办主任（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.firstsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.firstsignimg !== '' && _vm.form.docData.firstsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.firstsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("拟稿：")]), _c('span', [_vm._v("拟稿人（签字）:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.createTime) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.signImgUrl !== '' && _vm.form.signImgUrl != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.signImgUrl,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.zsNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1)], 1) : _vm._e(), _vm.form.tempId == 2 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("中共绵阳中学英才学校委员会拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.fileCode) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.urgency) + " ")])])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.secretLevel) + " ")])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.fileName))])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, _vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
      attrs: {
        "type": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownPreview(item);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e()], 1);
  }), 0)])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.signauditopinion) + " "), _c('div', {
    staticClass: "sign-content"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("党委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem",
      "white-space": "nowrap"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.signsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.signsignimg !== '' && _vm.form.docData.signsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.signsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-first-height"
  }, [_c('div', [_vm._v("复核：")]), _c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.secondauditopinion) + " "), _c('div', {
    staticClass: "sign-content-fuhe"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("专职副书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "1.625rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.secondsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.secondsignimg !== '' && _vm.form.docData.secondsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.secondsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" 初核： ")]), _c('span', [_vm._v(" " + _vm._s(_vm.form.docData.firstauditopinion) + " ")])]), _c('span', [_vm._v("党委办负责人（主任）签字:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.docData.firstsigndate) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.docData.firstsignimg !== '' && _vm.form.docData.firstsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.docData.firstsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("拟稿：")]), _c('span', [_vm._v("拟稿人（签字）:")]), _c('br'), _c('span', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v(" 日期：" + _vm._s(_vm.form.createTime) + " ")])]), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm.form.signImgUrl !== '' && _vm.form.signImgUrl != undefined ? _c('img', {
    staticStyle: {
      "height": "4.95rem"
    },
    attrs: {
      "src": _vm.form.signImgUrl,
      "alt": ""
    }
  }) : _vm._e()])], 1)], 1)])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v(" 会签： "), _vm.form.meetingResult === 0 ? _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" 不通过 ")]) : _vm._e(), _vm.form.meetingResult === 1 ? _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(" 通过 ")]) : _vm._e()]), _vm.form.docData.meetingImg.length > 0 ? _c('div', {
    staticClass: "content-font"
  }, _vm._l(_vm.form.docData.meetingImg, function (item, index) {
    return _c('span', {
      key: index
    }, [_c('img', {
      attrs: {
        "height": "60",
        "src": "".concat(_vm.config.baseUrl).concat(item)
      }
    })]);
  }), 0) : _vm._e()])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.zsNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送：")]), _c('div', {
    staticClass: "content-font double-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-left"
  }, [_c('div', [_vm._v("打印：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.form.docData.printsignimg !== '' && _vm.form.docData.printsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.printsignimg,
      "alt": ""
    }
  }) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("校对：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.form.docData.proofreadsignimg !== '' && _vm.form.docData.proofreadsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.proofreadsignimg,
      "alt": ""
    }
  }) : _vm._e()])]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("份数：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right",
    staticStyle: {
      "text-align": "center",
      "color": "black"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.docData.shareency) + " ")])])], 1)], 1) : _vm._e(), _vm.form.tempId == 3 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校发文审批单")]), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form2-content-top-left"
  }, [_vm._v(" 理事长签发： "), _c('span', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.chairmanauditopinion) + " "), _vm.form.docData.chairmansignimg !== '' && _vm.form.docData.chairmansignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.chairmansignimg,
      "alt": ""
    }
  }) : _vm._e()])])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_vm._v("拟稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("审稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("分管校级领导审核")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("会签")])]), _c('a-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_c('span', {
    staticClass: "content-font"
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.form.docData.draftauditopinion) + " ")]), _c('a-col', {
    attrs: {
      "span": 4
    }
  }, [_vm.form.docData.draftsignimg !== '' && _vm.form.docData.draftsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.draftsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.form.docData.reviewerauditopinion) + " ")]), _c('a-col', {
    attrs: {
      "span": 4
    }
  }, [_vm.form.docData.reviewersignimg !== '' && _vm.form.docData.reviewersignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.reviewersignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.form.docData.leadauditopinion) + " ")]), _c('a-col', {
    attrs: {
      "span": 4
    }
  }, [_vm.form.docData.leadsignimg !== '' && _vm.form.docData.leadsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.docData.leadsignimg,
      "alt": ""
    }
  }) : _vm._e()])], 1)]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left"
  }, [_c('div', [_vm._v("日期")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.form.formDate))])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left double-height"
  }, [_c('div', [_vm._v("标题")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right double-height"
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.fileName) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height"
  }, [_c('div', [_vm._v("抄送")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height"
  }, [_c('div', {
    staticClass: "content-font triple-height-content"
  }, [_vm._v(" " + _vm._s(_vm.form.csNameList.join(',')) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height"
  }, [_c('div', [_vm._v("附件")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height-content"
  }, [_c('div', {
    staticClass: "content-font"
  }, _vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
      attrs: {
        "type": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownPreview(item);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e()], 1);
  }), 0)])])], 1)], 1) : _vm._e(), _vm.form.tempId == 4 ? _c('div', [_c('div', {
    staticClass: "form-title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(" 绵阳中学英才学校公文处理笔笺 ")]), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.form.fileCode || ''))]), _c('a-row', [_c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("公文标题")])])]), _c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.filename) + " ")])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("拟办意见")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.proposedauditopinion || '') + " "), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem",
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "padding-right": "10px"
    }
  }, [_vm.form.docData.proposedsignimg !== '' && _vm.form.docData.proposedsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.proposedsignimg,
      "alt": ""
    }
  }) : _vm._e()]), _c('span', [_vm._v(" " + _vm._s(_vm.form.proposedsigndate) + " ")])])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("党委书记批示")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(" " + _vm._s(_vm.form.docData.memorandumauditopinion || '') + " "), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem",
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "padding-right": "10px"
    }
  }, [_vm.form.docData.memorandumsignimg !== '' && _vm.form.docData.memorandumsignimg != undefined ? _c('img', {
    staticStyle: {
      "height": "2.7rem"
    },
    attrs: {
      "src": _vm.form.memorandumsignimg,
      "alt": ""
    }
  }) : _vm._e()]), _c('span', [_vm._v(" " + _vm._s(_vm.form.memorandumsigndate) + " ")])])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("办理结果")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, [_vm._v(_vm._s(_vm.fillData.result))])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("附件")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height-content",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  }, _vm._l(_vm.form.fileList, function (item) {
    return _c('div', {
      key: item.uid
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.handlePreview(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm.form.fileList && _vm.form.fileList.length != 0 ? _c('a-button', {
      attrs: {
        "type": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDownPreview(item);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e()], 1);
  }), 0)])])], 1), _c('span', {
    staticStyle: {
      "display": "block",
      "padding": "10px",
      "font-size": "1.825rem",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v(" 发布范围 ")]), _c('div', {
    staticClass: "user-container"
  }, _vm._l(this.form.copyDelivery.userData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "user-box"
    }, [_c('div', {
      staticClass: "user-box-row"
    }, [_c('a-icon', {
      attrs: {
        "type": "tag"
      }
    }), _c('div', {
      staticClass: "wto",
      attrs: {
        "title": "".concat(item.name)
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1)]);
  }), 0)], 1) : _vm._e()])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_c('a-timeline', _vm._l(_vm.flowList, function (item, index) {
    return _c('a-timeline-item', {
      key: index,
      attrs: {
        "color": item.auditStatus === 1 ? 'rgb(79, 191, 73)' : item.auditStatus === 0 ? 'rgb(220, 33, 39)' : 'rgb(24, 144, 255)'
      }
    }, [_c('div', {
      staticClass: "timeline-title",
      attrs: {
        "title": item.auditStepName
      }
    }, [_vm._v(" " + _vm._s(item.auditStepName || '') + " ")]), _c('a-card', {
      staticClass: "processMsg",
      attrs: {
        "body-style": {
          padding: '10px'
        }
      }
    }, [item.auditStep === 3 && _vm.form.tempId === 2 ? _c('a-row', [item.counterSignChildren !== null ? _c('a-table', {
      attrs: {
        "size": "small",
        "dataSource": item.counterSignChildren,
        "columns": _vm.columns,
        "pagination": false,
        "rowKey": "number",
        "showHeader": false
      },
      scopedSlots: _vm._u([{
        key: "auditStatus",
        fn: function fn(text, record) {
          return [record.auditStatus === 0 ? _c('a-tag', {
            staticClass: "tag-border-red"
          }, [_vm._v(" 不通过 ")]) : _vm._e(), record.auditStatus === 1 ? _c('a-tag', {
            staticClass: "tag-border-green"
          }, [_vm._v(" 通过 ")]) : _vm._e(), record.auditStatus === 2 ? _c('a-tag', {
            staticClass: "tag-border-orange"
          }, [_vm._v(" 弃票 ")]) : _vm._e(), record.auditStatus === -1 ? _c('a-tag', {
            staticClass: "tag-border-black"
          }, [_vm._v(" 未投票 ")]) : _vm._e()];
        }
      }], null, true)
    }) : _vm._e(), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v(" 会签过期时间：" + _vm._s(item.expireTime) + " ")]), item.auditStep !== 0 ? _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('会签范围：') + " "), _c('a-tooltip', {
      attrs: {
        "title": item.organName + '/' + item.postName
      }
    }, [item.organName ? _c('a-tag', {
      staticStyle: {
        "text-overflow": "ellipsis",
        "max-width": "200px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "vertical-align": "bottom"
      },
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.postName) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v(" 会签结果： "), item.auditStatus !== 1 && item.auditStatus !== 0 ? _c('a-tag', {
      staticClass: "tag-border-blue"
    }, [_vm._v(" 待审批 ")]) : _vm._e(), item.auditStatus === 1 ? _c('a-tag', {
      staticClass: "tag-border-green"
    }, [_vm._v(" 通过 ")]) : _vm._e(), item.auditStatus === 0 ? _c('a-tag', {
      staticClass: "tag-border-red"
    }, [_vm._v(" 不通过 ")]) : _vm._e()], 1), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v(" 会签比例：" + _vm._s(item.passPercentage) + "% ")]), _c('a-col', {
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v(" 计算公式：通过人数 ÷ 总人数 x 100% ＝ 比例 ")])], 1) : _c('a-row', [item.auditStep === 0 ? _c('div', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(" " + _vm._s(item.auditStepName + '人：' + "".concat(item.userName === null ? '' : item.userName)) + " "), _c('a-tooltip', {
      attrs: {
        "title": item.organName + '/' + item.postName
      }
    }, [item.organName ? _c('a-tag', {
      staticStyle: {
        "text-overflow": "ellipsis",
        "max-width": "200px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "vertical-align": "bottom"
      },
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.organName) + "/" + _vm._s(item.postName) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), item.auditStep !== 0 ? _c('div', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('span', [_vm._v(" " + _vm._s('审核人：' + "".concat(item.userName === null ? '' : item.userName)) + " ")]), _c('a-tooltip', {
      attrs: {
        "title": item.organName + '/' + item.postName
      }
    }, [item.organName ? _c('a-tag', {
      staticStyle: {
        "text-overflow": "ellipsis",
        "max-width": "200px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "vertical-align": "bottom"
      },
      attrs: {
        "color": "#bfbfbf"
      }
    }, [_vm._v(" " + _vm._s(item.organName) + "/" + _vm._s(item.postName) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), item.auditStep === 0 ? _c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('拟稿时间：' + "".concat(item.processTime === null ? '' : item.processTime, " ")) + " ")]) : _vm._e(), item.auditStep !== 0 ? _c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('审核时间：' + "".concat(item.processTime === null ? '' : item.processTime, " ")) + " ")]) : _vm._e(), item.auditStep !== 0 ? _c('a-col', [_vm._v(" 审核状态： "), item.auditStatus !== 1 && item.auditStatus !== 0 ? _c('a-tag', {
      staticClass: "tag-border-blue"
    }, [_vm._v(" 待审批 ")]) : _vm._e(), item.auditStatus === 1 ? _c('a-tag', {
      staticClass: "tag-border-green"
    }, [_vm._v(" 通过 ")]) : _vm._e(), item.auditStatus === 0 ? _c('a-tag', {
      staticClass: "tag-border-red"
    }, [_vm._v(" 不通过 ")]) : _vm._e()], 1) : _vm._e(), item.auditStep !== 0 ? _c('a-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v(" " + _vm._s('审核意见：' + "".concat(item.auditOpinion === null ? '' : item.auditOpinion, " ")) + " ")]) : _vm._e()], 1)], 1)], 1);
  }), 1)], 1)], 1)], 1), _c('a-modal', {
    attrs: {
      "visible": _vm.previewShow,
      "footer": null,
      "centered": true,
      "width": "80rem"
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.previewSrc,
      "seamless": ""
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "printTable"
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.printSrc,
      "seamless": "",
      "id": "printFrame"
    }
  })]), _c('a-modal', {
    attrs: {
      "visible": _vm.distriVisible,
      "centered": true,
      "title": "分发",
      "maskClosable": false,
      "ok-text": "确认",
      "cancel-text": "取消"
    },
    on: {
      "cancel": _vm.distriCancel,
      "ok": _vm.submitSend
    }
  }, [_c('a-form-model', {
    ref: "sendForm",
    attrs: {
      "model": _vm.sendForm,
      "rules": _vm.rules
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否继续分发",
      "prop": "isIssue",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.sendForm.isIssue,
      callback: function callback($$v) {
        _vm.$set(_vm.sendForm, "isIssue", $$v);
      },
      expression: "sendForm.isIssue"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")]), _c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")])], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-cascader', {
    ref: "currOrganCascader",
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.form.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.organPostId"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "分发",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "result"
    }
  }, [_c('select-person', {
    ref: "personPick",
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.sendForm.result,
      callback: function callback($$v) {
        _vm.$set(_vm.sendForm, "result", $$v);
      },
      expression: "sendForm.result"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };